export enum RouteName {
  List = 'merchant-payouts',
}
